//Galery

export const farmImagesAlt = [
  "https://i.ibb.co/547yycL/20241021121523-IMG-2964.jpg",
  "https://i.ibb.co/PGy4xhH/20241021121539-IMG-2973.jpg",
  "https://i.ibb.co/FDbFsFP/20241021121611-IMG-2976.jpg",
  "https://i.ibb.co/Gnm1Pct/20241021122106-IMG-2998.jpg",
  "https://i.ibb.co/MkzC3xt/20241021122209-IMG-3010.jpg",
  "https://i.ibb.co/Mn2FzVG/20241021122340-IMG-3019.jpg",
  "https://i.ibb.co/wL4tzCW/20241021122715-IMG-3029.jpg",
  "https://i.ibb.co/C9DP2fT/20241021122736-IMG-3030.jpg",
  "https://i.ibb.co/v49NqDV/20241021122810-IMG-3033.jpg",
  "https://i.ibb.co/QjtBqMM/20241021122839-IMG-3035.jpg",
  "https://i.ibb.co/fr7VKPr/20241021122908-IMG-3037.jpg",
  "https://i.ibb.co/FwgLmxT/20241021122956-IMG-3039.jpg",
  "https://i.ibb.co/vJ9ZXd0/20241021123128-IMG-3046.jpg",
  "https://i.ibb.co/mSVSVrg/20241021123142-IMG-3047.jpg",
  "https://i.ibb.co/dPWP89Q/20241021123238-IMG-3050.jpg",
  "https://i.ibb.co/Ny4dqkt/20241021123504-IMG-3064.jpg",
  "https://i.ibb.co/F7XF2FG/20241021123533-IMG-3066.jpg",
  "https://i.ibb.co/gw6XQ5S/20241021123548-IMG-3068.jpg",
  "https://i.ibb.co/yyz5MM3/20241021123610-IMG-3071.jpg",
  "https://i.ibb.co/V9g5ftq/20241021123823-IMG-3080.jpg",
  "https://i.ibb.co/sVPNkTk/20241021123837-IMG-3083.jpg",
  "https://i.ibb.co/L06qWDH/20241021123900-IMG-3085.jpg",
  "https://i.ibb.co/0YvGP6g/20241021123929-IMG-3091.jpg",
  "https://i.ibb.co/SvfFkrT/20241021123943-IMG-3093.jpg",
  "https://i.ibb.co/ys19mzc/20241021121949-IMG-2994-copy.jpg",
  "https://i.ibb.co/X49frP2/20241021121948-IMG-2993-copy.jpg",
];
export const farmImages = [
  {
    url: "https://i.ibb.co/mSVSVrg/20241021123142-IMG-3047.jpg",
    alt: "Horse 7",
  },
  {
    url: "https://i.ibb.co/sVPNkTk/20241021123837-IMG-3083.jpg",
    alt: "Camel 2",
  },
  {
    url: "https://i.ibb.co/Gnm1Pct/20241021122106-IMG-2998.jpg",
    alt: " Horse 3",
  },
  {
    url: "https://i.ibb.co/Mn2FzVG/20241021122340-IMG-3019.jpg",
    alt: "Horse 5",
  },
  {
    url: "https://i.ibb.co/FDbFsFP/20241021121611-IMG-2976.jpg",
    alt: "Ducks",
  },
  {
    url: "https://i.ibb.co/QjtBqMM/20241021122839-IMG-3035.jpg",
    alt: "rabbit 1",
  },
  {
    url: "https://i.ibb.co/gw6XQ5S/20241021123548-IMG-3068.jpg",
    alt: "farm view",
  },
  {
    url: "https://i.ibb.co/v49NqDV/20241021122810-IMG-3033.jpg",
    alt: "Roosters 3",
  },
  {
    url: "https://i.ibb.co/X49frP2/20241021121948-IMG-2993-copy.jpg",
    alt: "Ducks 1",
  },
  {
    url: "https://i.ibb.co/C9DP2fT/20241021122736-IMG-3030.jpg",
    alt: "Roosters 2",
  },
  {
    url: "https://i.ibb.co/wL4tzCW/20241021122715-IMG-3029.jpg",
    alt: "Roosters 1",
  },
  {
    url: "https://i.ibb.co/L06qWDH/20241021123900-IMG-3085.jpg",
    alt: "Donkey 2",
  },
  {
    url: "https://i.ibb.co/yyz5MM3/20241021123610-IMG-3071.jpg",
    alt: "Horses trip",
  },

  {
    url: "https://i.ibb.co/fr7VKPr/20241021122908-IMG-3037.jpg",
    alt: "rabbit 2",
  },
  {
    url: "https://i.ibb.co/547yycL/20241021121523-IMG-2964.jpg",
    alt: "horse 1",
  },
  {
    url: "https://i.ibb.co/vJ9ZXd0/20241021123128-IMG-3046.jpg",
    alt: "Horse 6",
  },
  {
    url: "https://i.ibb.co/ys19mzc/20241021121949-IMG-2994-copy.jpg",
    alt: "Ducks 2",
  },
  {
    url: "https://i.ibb.co/Ny4dqkt/20241021123504-IMG-3064.jpg",
    alt: "A woman riding a horse 1",
  },

  {
    url: "https://i.ibb.co/F7XF2FG/20241021123533-IMG-3066.jpg",
    alt: "A woman riding a horse 2",
  },
  {
    url: "https://i.ibb.co/MkzC3xt/20241021122209-IMG-3010.jpg",
    alt: "Horse 4",
  },
  {
    url: "https://i.ibb.co/dPWP89Q/20241021123238-IMG-3050.jpg",
    alt: "the farm enterance",
  },
  {
    url: "https://i.ibb.co/PGy4xhH/20241021121539-IMG-2973.jpg",
    alt: "horse 2",
  },
  {
    url: "https://i.ibb.co/FwgLmxT/20241021122956-IMG-3039.jpg",
    alt: "parrot",
  },
  {
    url: "https://i.ibb.co/V9g5ftq/20241021123823-IMG-3080.jpg",
    alt: "Camel 1",
  },
  {
    url: "https://i.ibb.co/SvfFkrT/20241021123943-IMG-3093.jpg",
    alt: "Camels 3",
  },
  {
    url: "https://i.ibb.co/0YvGP6g/20241021123929-IMG-3091.jpg",
    alt: "Donkey 1",
  },
];

//Info
export const embdedVideos = [
  "https://www.youtube.com/embed/y893yE4TudA",
  "https://www.youtube.com/embed/y893yE4TudA",
  "https://www.youtube.com/embed/y893yE4TudA",
  "https://www.youtube.com/embed/FvCuon94haA",
  "https://www.youtube.com/embed/FvCuon94haA",
  "https://www.youtube.com/embed/FvCuon94haA",
];
//home

export const home_images2 = [
  "https://i.ibb.co/547yycL/20241021121523-IMG-2964.jpg",
  "https://i.ibb.co/C9DP2fT/20241021122736-IMG-3030.jpg",

  "https://i.ibb.co/PGy4xhH/20241021121539-IMG-2973.jpg",
  "https://i.ibb.co/MkzC3xt/20241021122209-IMG-3010.jpg",
  "https://i.ibb.co/QjtBqMM/20241021122839-IMG-3035.jpg",
  "https://i.ibb.co/F7XF2FG/20241021123533-IMG-3066.jpg",
];
//Team farm
export const farmTeams = [
  {
    name: "יוני להב",
    title: "מנהל חווה ומדריך רכיבה טיפולית",
    image: "https://i.ibb.co/cbrKHtF/image.png",
  },

  {
    name: "אורי שי",
    title: "מדריך רכיבה טיפולית/Reining  ",
    image: "https://i.ibb.co/ftwLT8F/image.jpg",
  },
  {
    name: "לירז מלול",
    title: "מדריכת רכיבה טיפולית/מערבית",
    image: "https://i.ibb.co/xfPKmjw/image.jpg",
  },
  {
    name: "מאיר ראובן",
    title: " מדריך רכיבה טיפולית",
    image: "https://i.ibb.co/YcL1Wfg/image.jpg",
  },
];
//posts
export const postsData = [
  {
    title: `רכיבה טיפולית: הדרך המיוחדת לחיבור גוף ונפש

`,
    content: `רכיבה טיפולית: הדרך המיוחדת לחיבור גוף ונפש

הסוס הוא חיה נטרפת, בעלת אינטליגנציה רגשית מפותחת מאוד, אך אינטליגנציה קוגניטיבית נמוכה. הוא מציב אתגרים ייחודיים לרוכב, ומבחן כוחו של הרוכב מתבצע כל הזמן, ברגעים של חיבור ותיאום. הסוס לא מקבל כל אחד כמנהיג, וכאשר הוא בודק את הרוכב, הוא מחפש אותו על פי קריטריונים מדויקים של תחושת ביטחון, סמכותיות ויכולת להעניק לו את מה שהוא צריך.

הרכיבה טיפולית משתמשת במערכת יחסים זו כדי לפתח תהליכים רגשיים, קוגניטיביים ומוטוריים אצל המטופל. דרך הקשר עם הסוס, הרוכב לומד על עצמו – על מנהיגות אמיתית, על איזון רגשי, אכפתיות, ועל כיצד לעבוד תחת לחצים מבלי לאבד שליטה. הסוס אינו מבקש להילחם, הוא מחפש אדם שיבין את הצרכים שלו ויתן לו ביטחון. רק אז הסוס יהיה מוכן להעניק את שירותיו – סוס שיסחוב את הרוכב על גבו, יאפשר לו לרוץ, לדהור ולחוות את הכוח הפיזי שלו בצורה משמעותית.

מנהיגות אמיתית בעבודה עם סוס

המנהיגות שמפתחת רכיבה טיפולית היא כזו שאין בה מקום לאגו. המנהיגות כאן אינה נמדדת בכוח או בפיקוד, אלא בזכות היכולת להקשיב ולהגיב באופן רגיש לצרכים של הסוס, להבין את מצבו, ולדעת כיצד להוביל אותו בצורה רגועה וביטחונית. הרוכב צריך ללמוד להפעיל מנהיגות בדרך שמבוססת על תכנון נכון, שמירה על גבולות, והתמקדות בפרטים הקטנים. הסוס, כפי שכבר צוין, לא יקבל כל רוכב כמנהיג – הוא יבחן כל אדם ויתנהג על פי האותות שיבחין בהם. הסוס לא מחפש "מנהיג" כוחני; הוא מחפש מישהו שידע להוביל אותו בדרך שמבוססת על ביטחון ושיתוף פעולה.

הסוס כמרכז חינוכי ורגשי

היכולת של הסוס להבין את רגשות הרוכב ולהגיב אליהם בצורה כל כך מדויקת, הופכת אותו למורה ברגישות ובאמפתיה. במקרים רבים, הסוס משמש כמראה לרגשות, לחששות ולפחדים של הרוכב. כאשר רוכב חושש, הסוס לא יגיב בהתלהבות או ב"שלום"; הסוס יבקש תחילה לבחון את הרוכב. רק כשזה ימצא את שלוותו הפנימית ויוכל להוביל את הסוס מתוך רגוע וביטחון, רק אז יוכל הסוס להגיב בצורה טובה. הרוכב לומד שליטה עצמית, התמודדות עם פחדים ויכולת לשחרר מתח תוך כדי רכיבה.

האינטליגנציה הרגשית של הסוס: מתנה מעולם הטבע

הסוס, ככל חיה נטרפת, פיתח אינטליגנציה רגשית מפותחת מאוד, שמאפשרת לו לזהות ולהגיב לסכנות מהסביבה. במהלך חיפוש אחר מזון, הסוס נמצא במצב שבו הוא חייב להימנע מטורפים, ומסיבה זו הוא מפתח את יכולתו לחוש את סביבתו גם מבלי מגע ישיר, וללא צורך בהשקעה רבה באנרגיה פיזית. הוא מבחין בשינויים קטנים באוויר, בריחות, בצלילים ובתנודות שונות, וכל אלו מאפשרים לו לזהות טורפים מרחוק. אם הוא מסוגל לחוש את הסביבה בצורה כל כך מדויקת, כאשר הוא נמצא מחוץ לסכנה, ניתן להבין עד כמה חזק הוא מסוגל לחוות את הרגשות של הרוכב עליו – את פחדיו, את תחושותיו ואת תחושת הביטחון שהוא מעניק לו. הסוס "מרגיש" את הרוכב עד עמקי נשמתו.

היופי שבמנהיגות – לא הכוח, אלא המוח

היופי שבסוס הוא שמה שעומד בבסיס היכולת לעבוד איתו לא נוגע לכוח פיזי. הסוס בעל כוח עצום, אך הוא מחפש לא את השריר, אלא את המוח. הוא רוצה רוכב שיודע לנהל אותו בעזרת חשיבה צלולה, רגישות והבנת הצרכים שלו. כל רוכב, אם רק יאמין בעצמו ויבין את המהות של מנהיגות אמיתית – לא כשליטה בכוח אלא כיכולת להנחות בצורה רגועה ונחושה – יכול להצליח. זה לא קשור לגיל או לכוח פיזי, אלא אך ורק ליכולת להאמין בעצמך ולהיות מנהיג אמיתי. כמו שנאמר, "זה לא הגיל, זה רק התרגיל."

הסוס כמשקף את הרוכב

הסוס משקף בצורה מדויקת את הרוכב. לא משנה כמה נסתרות או מוחזרות תחושותיו של הרוכב, הסוס "רואה" ומגיב להם. גם אם הרוכב מנסה להסתיר את פחדיו או חרדותיו, הסוס יבחין ויגיב בהתאם. הסוס לא שופט, הוא רק מגיב למה שהוא מרגיש מהסביבה. לכן המשפט המפורסם מטקסס מהאקדוחנים והקאבויים, "תראה לי את סוסך ואגיד לך מי אתה", מבטא את האמת הפשוטה – הסוס תמיד יגלה את האישיות האמיתית של הרוכב. הסוס אינו יכול להיות מושא למניפולציות – הוא מרגיש אם הרוכב אמיתי, אם הוא שלם עם עצמו ועם רגשותיו, ואם הוא מסוגל להיות המנהיג שהוא שואף להיות.

מנהיגות כיכולת לגמישות נפשית ורגשית

היכולת להיות מנהיג אינה בהכרח קשורה רק למעשיות או לשליטה מוחלטת. ההפך – מנהיגות אמיתית נמדדת ביכולת להבין מתי לוותר, מתי להילחם ומתי להקשיב. הרוכב לומד להניח לרגשות שלו להתאזן, לדעת מתי להגיב ומתי לשחרר את המתח. הסוס, עם האינטליגנציה הרגשית המפותחת שלו, לא שופט, אך מבקש שיבינו אותו ויתנו לו את התחושה שהוא בטוח. הסוס מגיב בצורה רגשית ועמוקה, ולפי הדרך בה הרוכב מתמודד עם אתגרי רכיבה, הוא משנה את התנהגותו.



ולסיכום

הסוס מציב אתגר, אך הוא גם כלי ללמידה עמוקה. הרוכב לומד כי כל דבר דורש התמודדות עם פחדים, עם תסכולים, ועם אתגרים. הרכיבה הטיפולית מאפשרת לכל אדם ללמוד ולגדול דרך הקשר עם הסוס, שמחייב את הרוכב להיות סבלני, קשוב ומובילי בדרך הנכונה. כל רוכב מוצא בסט הקשרים הזה את האתגרים שמובילים אותו להיות אדם טוב יותר, מלא יותר ומחובר יותר לעצמו.`,
    authorName: farmTeams[0]?.name,
    farmTitle: farmTeams[0]?.title,
    date: "03/12/2024",
    authorImage: farmTeams[0]?.image,
  },
];

export const addvertisementImages = [
  {
    url: "https://i.ibb.co/k2tr7cr9/image.jpg",
    alt: "addvertisment1",
    fromDate: "2025-08-10",
    toDate: "2025-09-01",
  },
  {
    url: "https://i.ibb.co/3q856YV/image.jpg",
    alt: "addvertisment2",
    fromDate: "2025-08-10",
    toDate: "2025-08-22",
  },
];

//functions
//functions that received an array, index and ecceptedLength and returns a new array
export const getCurrentElements = (arr, index, ecceptedLength) => {
  const result = [];
  for (let i = 0; i < ecceptedLength; i++) {
    const currentIndex = (Math.abs(index) + i) % arr.length;
    result.push(arr[currentIndex]);
  }
  return result;
};

export const aboutUs = `ברוכים הבאים ל"חווה של חן" – פינת גן עדן בלב הטבע, שבה חלומות מתגשמים וחוויות בלתי נשכחות מחכות לכם. אנחנו מתמחים ברכיבה טיפולית, המשלבת בין כוח הריפוי של הטבע, בעלי החיים והסוסים לבין חוויית רכיבה מעצימה ומחברת.

מעבר לכך, אנו מציעים רכיבה ספורטיבית בסגנון אולראונד מערבי (Western Riding), המתאימה לכל מי שרוצה להתנסות בסגנון רכיבה ייחודי ומאתגר – חוויה של חופש, דיוק והרמוניה.

אבל החוויה לא נגמרת כאן – בחווה תמצאו פינת חי קסומה עם גמלים, חמורים, תוכים, ארנבות, תרנגולים וברווזים, וכל אלה בתוך תפאורה כפרית אותנטית.

במרכז החווה שוכן האוהל הבדואי הייחודי שלנו, המיועד לאירועים פרטיים כמו ימי הולדת, בריתות, בת מצוות ואירועים מיוחדים נוספים. ניתן לשלב באירועים פעילויות רכיבה, סדנאות יצירה, ופינות חי לכל המשפחה – לחוויה שלא תשכחו.

הנופים הקסומים, השלווה הכפרית והחיבור המיוחד בין האדם לטבע הופכים את "החווה של חן" למקום שבו תרצו לבלות, לחגוג וליצור זיכרונות. בואו להתאהב!

`;

export const handleNext = (setIndex) => {
  setIndex((prev) => prev + 1);
};
export const handlePrev = (setIndex) => {
  setIndex((prev) => prev - 1);
};
